import React from "react"
import {
  DownloadTableContainer,
  DownloadableRowStyle,
} from "./quick-start.styled"
import useTranslationHook from "../../../../../hooks/use-translation.hook"
import { AppFunctionComponent } from "../../../../../types"
import { IManuals } from "./quick-start.interface"

interface QuickStartManualsTableProps {
  manuals: IManuals[]
}

const QuickStartManualsTable: AppFunctionComponent<
  QuickStartManualsTableProps
> = ({ manuals }) => {
  const { translate } = useTranslationHook()
  return (
    <DownloadTableContainer>
      <DownloadableRowStyle>
        <p className="first heading">{translate("Name")}</p>

        <p className="fourth heading"></p>
      </DownloadableRowStyle>
      {manuals.map(({ name, downloadLink }) => (
        <DownloadableRowStyle key={name}>
          <p className="first bolded">{name}</p>

          <p className="fourth bolded">
            <a href={downloadLink} target="_blank" rel="noreferrer">
              {translate("Download")}
            </a>
          </p>
        </DownloadableRowStyle>
      ))}
    </DownloadTableContainer>
  )
}

export default QuickStartManualsTable
